import React, { Component } from 'react';
import cross from '../../assets/images/shape-cross.svg';
import banner from '../../assets/images/Banner.jpg';


export default class FriendlyCallsModal extends Component {
    // constructor() {
    //     super()
    // }

    render() {
        if (this.props.isModalOpen === true) {
            return (
                <div class="modal" style={{ display: 'block' }} id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel">
                    <div class="modal-dialog friendly-calls-modal" role="document">
                        <div class="modal-content">
                            <div className="friendly-calls-main-div">
                                <div class="friendly-back-link" >
                                    <img src={cross} alt="loading..." onClick={() => this.props.HideFriendlyCallsModal()} />

                                </div>

                                <div className="container">
                                    <div class="friendly-calls-div">
                                        <div class="row">
                                            <div class="col-md-12 col-lg-12">
                                                <div class="friendly-calls-img-div">
                                                    <img src={banner} alt="loading..." />
                                                </div>
                                            </div>
                                            <div class="col-md-12 col-lg-12">
                                                <div class="friendly-calls-heading">
                                                    <h4>Join our Friendly Calls check-in program</h4>
                                                </div>
                                            </div>
                                            <div class="col-md-12 col-lg-12">
                                                <div class="friendly-calls-content">
                                                    <p>A short phone call that makes it easy to be social from the comfort of home. Ask for help with daily tasks, talk about your favorite subjects, or just say hello!
                                                    <br/>
                                                    <br/>
                                                    Friendly Calls are included with a Kinship membership. Pick the best time for them to receive a phone call on a weekday.
                                                    </p>
                                                    
                                                </div>
                                            </div>
                                            <div class="col-md-12 col-lg-12">
                                                <div class="checkbox-div">
                                                    <h6>Select all that apply:</h6>
                                                </div>
                                                <div class="form-check">
                                                    <input class="form-check-ausi" type="checkbox" value="" id="defaultCheck1" />
                                                    <label class="form-check-label-ausi" for="defaultCheck1">
                                                    Mornings (9am ET - Noon ET)
                                                    </label>
                                                </div>
                                                <div class="form-check">
                                                    <input class="form-check-ausi" type="checkbox" value="" id="defaultCheck1" />
                                                    <label class="form-check-label-ausi" for="defaultCheck1">
                                                    Afternoons (Noon ET - 4pm ET)
                                                    </label>
                                                </div>
                                                <div class="form-check">
                                                    <input class="form-check-ausi" type="checkbox" value="" id="defaultCheck1" />
                                                    <label class="form-check-label-ausi" for="defaultCheck1">
                                                    Evenings (4pm ET - 7pm ET)
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="col-md-12 col-lg-12">
                                            <div class="friendly-seperation-line">
                                            </div>
                                            </div>
                                            <div class="col-md-12 col-lg-12">
                                            <div class="friendly-save-btn-div">
                                            <button type="button" class="btn friendly-save-btn" data-dismiss="modal"
                                                onClick={() => this.props.HideFriendlyCallsModal()}
                                            >Save Changes</button>
            
                                        </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>

                           
                        </div>
                    </div>
                </div>
            )
        }
        else return null
    }
}